import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

const WhatsAppButton = () => {
  return (
    <a
    
    href="https://wa.me/+16472135742?text=Hi%2C%20I%20need%20help%20with%20choosing%20the%20right%20blinds%20for%20my%20space."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-40 right-5 bg-green-600 text-white p-3 md:p-4 rounded-full shadow-lg hover:bg-green-500 transition-colors duration-300 flex items-center justify-center"
      style={{ zIndex: 1000 }}
    >
      <i className="fab fa-whatsapp text-white" style={{ fontSize: '30px' }}></i> 
    </a>
  );
};

export default WhatsAppButton;
